export default __webpack_public_path__ + "static/media/9-Solar System.890e71a5.svg";